import "core-js/modules/es.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import checkPermission from '@/utils/permission';
export default {
  props: {
    tabsArr: {
      type: Array,
      default: function _default() {
        return [{
          label: 'tab1',
          name: 'tab1',
          // 注意name必须是唯一的（因为name作为插槽的name使用了）
          permission: []
        }, {
          label: 'tab2',
          name: 'tab2',
          permission: []
        }];
      }
    }
  },
  data: function data() {
    return {};
  },
  created: function created() {
    // 处理选中tab
    for (var i = 0; i < this.tabsArr.length; i++) {
      if (this.tabsArr[i].permission && checkPermission(this.tabsArr[i].permission)) {
        this.$emit('dealSelect', this.tabsArr[i].name);
        break;
      }
    }
  },
  methods: {
    checkPermission: checkPermission
  }
};